export default class Header {
	static init() {
		new Header(document.querySelector('.header'));
	}

    isOpen = false;
    isMobile = window.innerWidth < 992;

	constructor(element) {
		if (!element) {
			return;
		}

        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 992;
        });

        const toggleButton = document.querySelector('.header__toggle-button');
        const dropdownMenuItems = document.querySelectorAll('li:has(.navigation__dropdown) > a');

		window.addEventListener('scroll', () => requestAnimationFrame(() => {
			element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');
		}));
		element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');

        window.addEventListener('click', (e) => {
            if (this.isMobile) {
                if (e.target.contains(toggleButton)) {
                    element.classList[this.isOpen ? 'remove' : 'add']('header--is-open');
                    this.isOpen = !this.isOpen;
                }
            }
        });

        dropdownMenuItems.forEach(el => {
            el.addEventListener('click', e => {
                if (this.isMobile) {
                    e.preventDefault();
                    e.stopPropagation();
                    el.parentNode.classList[el.parentNode.classList.contains('is-open') ? 'remove' : 'add']('is-open');
                }
            });
        });
	}
}
